import classes from './AiAgentIcon.module.css';
import cx from 'clsx';
import { CSSProperties, type FunctionComponent } from 'react';
import { VisuallyHidden } from '@mantine/core';

export interface AiAgentIconProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  className?: string;
  alt?: string;
}

// TODO: CRE-3662, CRE-3661: Improve SVG importing to support any icon image (and use SVG icon sprite)
// This is a snapshot of @/icons/custom/sparkle-filled.svg.
const svgInlineData = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
<path d="M17.2372 10.9209L21.577 9.47434C22.0328 9.32239 22.0328 8.67761 21.577 8.52566L17.2372 7.07906C17.0879 7.02929 16.9707 6.91213 16.9209 6.76283L15.4743 2.42302C15.3224 1.96718 14.6776 1.96718 14.5257 2.42302L13.0791 6.76283C13.0293 6.91213 12.9121 7.02929 12.7628 7.07906L8.42303 8.52566C7.96718 8.67761 7.96718 9.32239 8.42303 9.47434L12.7628 10.9209C12.9121 10.9707 13.0293 11.0879 13.0791 11.2372L14.5257 15.577C14.6776 16.0328 15.3224 16.0328 15.4743 15.577L16.9209 11.2372C16.9707 11.0879 17.0879 10.9707 17.2372 10.9209Z" />
<path d="M7.81474 18.5618L9.86158 17.8795C10.2263 17.7579 10.2263 17.2421 9.86158 17.1205L7.81474 16.4382C7.69529 16.3984 7.60157 16.3047 7.56175 16.1853L6.87947 14.1384C6.75791 13.7737 6.24209 13.7737 6.12053 14.1384L5.43825 16.1853C5.39843 16.3047 5.3047 16.3984 5.18526 16.4382L3.13842 17.1205C2.77374 17.2421 2.77374 17.7579 3.13842 17.8795L5.18526 18.5618C5.3047 18.6016 5.39843 18.6953 5.43825 18.8147L6.12053 20.8616C6.24209 21.2263 6.75791 21.2263 6.87947 20.8616L7.56175 18.8147C7.60157 18.6953 7.69529 18.6016 7.81474 18.5618Z" />
</svg>`;

const iconUrl = `data:image/svg+xml;base64,${btoa(svgInlineData)}`;

const AiAgentIcon: FunctionComponent<AiAgentIconProps> = ({
  className,
  size,
  alt,
}) => {
  const dataAttrs = {
    'data-size': size,
  };

  const inlineStyle = {
    '--icon-data': `url(${iconUrl})`,
  } as CSSProperties;

  return (
    <div
      className={cx(className, classes.root)}
      {...dataAttrs}
      style={inlineStyle}>
      <VisuallyHidden>{alt}</VisuallyHidden>
    </div>
  );
};

export default AiAgentIcon;
